import React, { useEffect, useState } from "react"
import { Box } from "@material-ui/core"
import { Helmet } from "react-helmet"
import { useParams } from "react-router-dom"
import { SongModel } from "models/SongModel"
import styles from "./songpage.module.scss"
import PlayerControls from "components/PlayerControls/PlayerControls"
import MouthBackground from "components/MouthBackground/MouthBackground"
import { logEvent } from "analyticsEvents"
import CardContainer from "components/CardContainer/CardContainer"
import RainbowButton from "components/RainbowButton/RainbowButton"
import { getSong, getSongAlbumArt, getSongPlaybackUrl } from "firestoreutils/firestoresongs"
import { getUserProfilePic } from "firestoreutils/firestoreusers"

interface Props {
  songId: string
  userId?: string
}

const SongPage = () => {
  const { songId } = useParams<Props>()
  const [song, setSong] = useState<SongModel>()
  const [profilePicUrl, setProfilePicUrl] = useState<string>()
  const [albumArt, setAlbumArt] = useState<string>()
  const [fontsLoaded, setFontsLoaded] = useState<boolean>(false)
  const [songPlayUrl, setSongPlayUrl] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    logEvent('song_page_loaded', {
      song_id: songId,
    });
    getSong(songId).then((song) => {
      if (!song) {
        console.error("No such song!");
        setError(true);
        return;
      }

      setSong(song);
      Promise.all([
        getSongAlbumArt(song),
        getSongPlaybackUrl(song.songID),
        getUserProfilePic(song.creatorID)
      ]).then(([albumArt, playUrl, creatorProfileUrl]) => {
        if (!albumArt || !playUrl) {
          setError(true);
          return;
        }
        setAlbumArt(albumArt);
        setSongPlayUrl(playUrl);
        setProfilePicUrl(creatorProfileUrl);
      });
    });
  }, [])

  useEffect(() => {
    // @ts-ignore
    document.fonts.ready.then(() => {
      setFontsLoaded(true);
    });
  }, [])

  useEffect(() => {
    if (songPlayUrl && song && albumArt && fontsLoaded) {
      setLoading(false)
    }
  }, [songPlayUrl, song, albumArt, fontsLoaded])

  const bodyContent = (!error && !loading) ?
      songMetadata(songPlayUrl, albumArt!, profilePicUrl || "", song!) :
      <div />
  return (
    <>
      <Helmet>
        <title>Mayk Song</title>
      </Helmet>
      <MouthBackground />
      <CardContainer loading={loading} error={error}>
        {bodyContent}
      </CardContainer>
    </>
  )
}

const onGetAppClicked = (songId: string) => {
  logEvent('get_app_clicked', { song_id: songId });
}

const songMetadata = (
  songPlayUrl: string,
  albumArtUrl: string,
  profilePicUrl: string,
  song: SongModel
) => {
  return (
    <>
    {headerContent()}
    <div className={styles.songMetadataContainer}>
      <div className={styles.albumArtWrapper}>
        <img src={albumArtUrl} className={styles.albumArt} />
      </div>
      <Box display='flex' flexDirection='row' margin='0 32px'>
        <div className={styles.songMetadata}>
          <div className={styles.songName}>{song?.title}</div>
          <div className={styles.userName}>{song?.artistName}</div>
        </div>
          <img className={styles.userProfile} src={profilePicUrl} />
      </Box>
      <div className={styles.controlsContainer}>
        <PlayerControls songUrl={songPlayUrl} songTitle={song.title} songId={song.songID}></PlayerControls>
      </div>
      <RainbowButton onClick={() => onGetAppClicked(song.songID)} href="https://link.mayk.it/rdYp/songDownloadLink">Get the App</RainbowButton>
    </div>
    </>
  )
}

const headerContent = () => {
  return (
    <Box justifyContent='center' display='flex' alignItems='center'>
        <img src={process.env.PUBLIC_URL + "/logo256.png"} alt='logo' className={styles.maykLogo} />
        <h3 className={styles.maykTitle}>mayk</h3>
    </Box>
  )
}

export default SongPage
